<template>
  <tr>
    <td>{{ fecha(inscripto.fecha) }}</td>
    <td>{{ inscripto.persona.nombre }}</td>
    <td>{{ inscripto.persona.apellido }}</td>
    <td>{{ inscripto.persona.email }}</td>
    <td>$ <span v-if="inscripto.monto != null">{{ parseFloat(inscripto.monto).toFixed(2).replace(/\.00$/, '') }}</span><span v-else> - </span></td>
    <td>{{ inscripto.forma_de_seminario.nombre }}</td>
    <td><span v-if="inscripto.sede != null">{{ inscripto.sede.nombre }}</span><span v-else> - </span></td>
  </tr>
</template>

<script>
export default {
  name: 'Samyoga2025ListaItem',
  components: {
  },
  props: ['inscripto'],
  data: function () {
    return {
      mostrar: true
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    },
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    }
  },
  mounted: function () {
    // if (this.pago.factura_url === null) {
    //   this.mostrar = false
    // }
  }
}
</script>

<style>
.icono-descarga {
  text-decoration: none;
  color: rgb(126,220,217);
  border: none;
  padding: 2px 5px;
  font: inherit;
  font-size: inherit;
  cursor: pointer;
  outline: inherit;
  font-size: 27px;
  line-height: 100%;
/*  margin: 0 12px;
  display: flex;*/
}
</style>
